import { render, staticRenderFns } from "./FormSwitch.vue?vue&type=template&id=4e195ef8&scoped=true"
import script from "./FormSwitch.vue?vue&type=script&lang=js"
export * from "./FormSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e195ef8",
  null
  
)

export default component.exports